export default __webpack_public_path__ + "msd-logo-white-4ce4ed564a2b9f32c562e91e9cd3342a.digested.png";